export default __webpack_public_path__ + "static/media/port3.ded5471c.png";